// extracted by mini-css-extract-plugin
export var contentDetailWrap = "index-module--contentDetailWrap--PUI8U";
export var header = "index-module--header--I3oIE";
export var standardCard = "index-module--standardCard--zFByB";